let sizesCount = $('.js-carousel-select-size .radio-label').length;

export default function () {
    // Carousel price
    /*
    $('.js-carousel-select-color').slick({
        slidesToShow: colorsCount <= 5 ? 9 : 7,
        slidesToScroll: 4,
        infinite: false,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: colorsCount <= 3 ? 8 : 7,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 10,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 2
                }
            }
        ]

    });
    */

    if (sizesCount > 16) {
        // Carousel size
        $('.js-carousel-select-size').slick({
            slidesToShow: 1.2,
            slidesToScroll: 1,
            infinite: false,
            responsive: [
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    // QuickView
    $('.js-carousel-select-color-quickview').slick({
        slidesToShow: 6,
        slidesToScroll: 2,
        infinite: false,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 10,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 2
                }
            }
        ]

    });
}
